// context/AudioContext.tsx
import { createContext, useContext, PropsWithChildren } from 'react'

import { useUiAudio } from '../../hooks/useAudio'

type AudioContextType = ReturnType<typeof useUiAudio>

const AudioContext = createContext<AudioContextType | null>(null)

export const AudioProvider = ({ children }: PropsWithChildren) => {
  const audio = useUiAudio()

  return <AudioContext.Provider value={audio}>{children}</AudioContext.Provider>
}

export const useAudio = () => {
  const ctx = useContext(AudioContext)
  if (!ctx) {
    throw new Error('useAudio must be used inside AudioProvider')
  }
  return ctx
}
